import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {ExtrudeGeometry} from "three";
import {GeometryModifier} from "./products/modifiers/types";

export interface ProductData {
    id: string;
    title: string;
    icon?: string;
    state: PRODUCT_STATE;
    topElement?: ExtrudeGeometry;
    bottomElement?: (radius: number) => ExtrudeGeometry;
    elements: ProductElement[];
    maxElements: number;
    disabled?: boolean
    description: string;
    images: string[];
    details: string[];
    policies: ProductPolicy[];
    default: ConfiguredElement[];
}

export type PRODUCT_STATE = 'NEW' | 'TBA';

export interface ProductVariant {
    id: string;
    editFunction?: VariantFunction;
}

export interface ProductElement {
    title: string;
    generatorFunction: (radius: number, values: GeneratorValues) => ExtrudeGeometry;
    params: ProductElementParam[];
    modifiers: ProductElementModifier[];
}

export type VariantFunction = (values: any) => any;

export type GeneratorValues = {
    height: number;
    [key: string]: number | string;
}

export interface ProductElementModifier {
    function: GeometryModifier;
    name: string;
    params: ProductElementParam[];
}

export interface ProductElementParam {
    type: ProductElementParamType;
    name: string;
    step: number;
    key: string;
    minValue: number;
    unit?: string;
    defaultValue: number | string;
    valMapper: (val: number) => number;
    maxValue: number;
}

export enum ProductElementParamType {
    HORIZONTAL_RANGE = 'HORIZONTAL_RANGE',
    TEXT = 'TEXT',
    SELECT = 'SELECT',
}

export interface ProductPolicy {
    name: string;
    icon: IconProp;
    description: string;
}

export interface ConfiguredElement {
    config: ProductElement;
    modifiers: ProductElementModifier[];
    values: GeneratorValues;
}